export default __webpack_public_path__ + "static/Inter-SemiBold-ab564c2dbbe039da8cb5293721b7590e.woff2";